import {Instant, LocalDateTime, ZonedDateTime} from '@js-joda/core';
import { PureComponent } from 'react';

import { DisplayDate } from './DisplayDate';
import { DisplayTime } from './DisplayTime';

interface Props {
  dateTimeValue: string | LocalDateTime | Instant | Date | ZonedDateTime;
  showWeekday?: boolean;
  showYear?: boolean;
  displayMonthAs?: 'numeric' | 'short' | 'long';
  displayWeekdayAs?: 'narrow' | 'short' | 'long';
  displayYearAs?: '2-digit' | 'numeric';
}

/**
 * Displays a date and time in the business locale.  Takes either a date and a time
 * or one string or LocalDateTime that contains both the date and the time.
 */
export class DisplayDateTime extends PureComponent<Props> {
  static defaultProps: Partial<Props> = {
    displayMonthAs: 'long',
  };

  render() {
    const {
      dateTimeValue,
      displayMonthAs,
      displayWeekdayAs,
      displayYearAs,
      showWeekday,
      showYear,
    } = this.props;

    return (
      <span>
        <DisplayDate
          displayMonthAs={displayMonthAs}
          displayWeekdayAs={displayWeekdayAs}
          displayYearAs={displayYearAs}
          showWeekday={showWeekday}
          showYear={showYear}
          dateValue={dateTimeValue}
        />
        , <DisplayTime timeValue={dateTimeValue} />
      </span>
    );
  }
}
